export const WIDGET_NOTE_PAGE_COLORS = [
  "#FFFFFF",
  "#C9E5FF",
  "#C9FFD8",
  "#FFC9C9",
  "#DBDBFF",
  "#FFF0C9",
] as const;
